import { FluidIntakeTemplate } from "app/features/reporting/templates/FluidIntakeTemplate";

export function FluidIntakeReportScreen() {
  return <FluidIntakeTemplate />;
}
